export default __webpack_public_path__ + "static/media/Leggings of the Usurper.508f00ab.jpg";